// Pad (trampoline): throws the ball back up
import { definePart } from '../core/registry';
import { Physics } from '../core/physics';
import { rr, lg, shadowOn, shadowOff, C } from '../core/draw-helpers';
import type { Ctx2D } from '../core/types';

export function drawPad(ctx: Ctx2D, x: number, y: number, a: number, w: number, h: number, sel?: boolean, squash?: number) {
  ctx.save(); ctx.translate(x, y); ctx.rotate(a);
  const s = squash || 0;
  // springs
  ctx.strokeStyle = '#8B84A0'; ctx.lineWidth = 3;
  for (const px of [-w / 3, 0, w / 3]) {
    ctx.beginPath(); ctx.moveTo(px, h / 2 + 10);
    for (let i = 0; i < 4; i++) ctx.lineTo(px + (i % 2 ? 6 : -6), h / 2 + 8 - i * (3 - s));
    ctx.stroke();
  }
  shadowOn(ctx, 10, 5);
  rr(ctx, -w / 2 - 4, h / 2 + 6, w + 8, 8, 4); ctx.fillStyle = '#6E6780'; ctx.fill();
  shadowOff(ctx);
  rr(ctx, -w / 2, -h / 2 + s * 3, w, h - s * 3, h / 2); ctx.fillStyle = lg(ctx, -h / 2, h / 2, C.red1, C.red2); ctx.fill();
  rr(ctx, -w / 2 + 8, -h / 2 + 2 + s * 3, w - 16, 4, 2); ctx.fillStyle = 'rgba(255,255,255,.55)'; ctx.fill();
  if (sel) { rr(ctx, -w / 2 - 3, -h / 2 - 3, w + 6, h + 22, 10); ctx.strokeStyle = '#fff'; ctx.lineWidth = 4; ctx.stroke(); }
  ctx.restore();
}

export const pad = definePart({
  rects: [{ x: 0, y: 0, w: 100, h: 16 }], rot: true, pad: true, thumb: false,
  draw(ctx, pl, sel) { const r = Physics.worldRects(pl)[0]; drawPad(ctx, r.x, r.y, r.a, r.w, r.h, sel, pl.squash); },
  icon: ctx => drawPad(ctx, 0, -6, 0, 86, 16),
  intro(x, t, g, { fakeBall, arrow }) {
    drawPad(x, 230, 222, 0, 120, 16, false, t > 46 && t < 56 ? 1 : 0);
    let y;
    if (t < 50) y = 30 + 0.075 * t * t; else if (t < 140) { const k = (t - 50) / 90; y = 212 - 190 * Math.sin(k * Math.PI); } else y = 212;
    g.ball(x, fakeBall(230, Math.min(y, 212) - 4, 0, t < 50 ? 8 : -3), 'hero', t);
    arrow(330, 120, 330, 70, true);
  },
});
